"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var experimentCommitListChains_1 = require("../experiment/experimentCommitListChains");
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
/**
 * Split selection into regions, and perform a block-wise formatting action for each region.
 */
function blockFormat(editor, callback, beforeRunCallback) {
    editor.focus();
    editor.addUndoSnapshot(function (start, end) {
        if (!beforeRunCallback || beforeRunCallback()) {
            var regions = editor.getSelectedRegions();
            var chains_1 = roosterjs_editor_dom_1.VListChain.createListChains(regions, start === null || start === void 0 ? void 0 : start.node);
            regions.forEach(function (region) { return callback(region, start, end, chains_1); });
            experimentCommitListChains_1.default(editor, chains_1);
        }
        editor.select(start, end);
    }, "Format" /* Format */);
}
exports.default = blockFormat;
//# sourceMappingURL=blockFormat.js.map